export const FIELD_MAPPINGS = {
  period: 'periodName',
  taxaccounting: 'taxDescription',
  enabledflag: 'enabledFlag',
  'p&l': 'plAccount',
  balancesheet: 'bsAccount',
  'reclassp&l': 'reclassPlAccount',
  reclassbalancesheet: 'reclassBsAccount',
  goldid: 'goldId',
};

export const MIN_COLUMNS_NUMBER = 8;
export const MAX_COLUMNS_NUMBER = 8;
